import React, { FC, useContext } from "react";
import { EventType, EventViewProps } from "../types";
import Pagination from "../Pagination";
import Telemetry from "../../../../utils/rudderstackAnalytics";
import Breadcrumbs from "../Breadcrumbs";
import LibraryFolders from "./LibraryFolders";
import LibraryEvents from "./LibraryEvents";
import DownloadEvents from "./DownloadEvents";
import {
  decodeEntityPath,
  getEncodedEntityPath,
  getEntitySegment
} from "../FolderFeatures/EncryptionOfFolder";
import { PhotoManagerContext } from "../index";

const EventView: FC<EventViewProps> = ({
  events,
  isMobile,
  folders,
  onFolderClick,
  onClickCreateLibraryFolder,
  handleEventClick,
  currentPage,
  nextPage,
  handlePageChange,
  setActiveShareModalEventId,
  setPrivacyPopupId,
  setMarkUploadCompletePopup,
  albumLoading,
  loading,
  showActionTooltip
}) => {
  const context = useContext(PhotoManagerContext);

  const handleEventClickWithNavigation = (event: EventType) => {
    Telemetry.track("content-library:event-opened", {
      source: "main-panel"
    });
    const url = new URL(window.location.href);
    const encodedPath = url.searchParams.get("p");
    const segment = getEntitySegment(event);
    const decodedPath = encodedPath ? decodeEntityPath(encodedPath) : "";
    const newPath = decodedPath ? `${decodedPath}/${segment}` : segment;
    const newEncodedPath = getEncodedEntityPath(newPath);
    if (newEncodedPath) {
      context?.setEncodedString(newEncodedPath);
      handleEventClick(event, newEncodedPath);
    }
  };

  const handleShowTooltip = (id: string, msg: string) =>
    $(`#${id} [data-toggle="tooltip"]`)
      .attr("data-original-title", `${msg}`)
      //@ts-ignore
      .tooltip("show");
  const handleHideTooltip = (id: string) =>
    $(`#${id} [data-toggle="tooltip"]`)
      //@ts-ignore
      .tooltip("hide");

  return (
    <div className="ws-album-list">
      <Breadcrumbs viewType="EventView" />
      <div>
        {!context?.invitedEventsMode && (
          <LibraryFolders
            libraryFolders={folders || []}
            onLibraryFolderClick={onFolderClick}
            onClickCreateLibraryFolder={onClickCreateLibraryFolder}
          />
        )}
      </div>

      <LibraryEvents
        events={events}
        albumLoading={albumLoading}
        showActionTooltip={showActionTooltip}
        handleEventClickWithNavigation={handleEventClickWithNavigation}
        setActiveShareModalEventId={setActiveShareModalEventId}
        setMarkUploadCompletePopup={setMarkUploadCompletePopup}
        setPrivacyPopupId={setPrivacyPopupId}
      />

      <DownloadEvents
        handleShowTooltip={handleShowTooltip}
        handleHideTooltip={handleHideTooltip}
      />

      <Pagination
        currentPage={currentPage}
        nextPage={nextPage}
        handlePageChange={handlePageChange}
        loading={loading}
      />
    </div>
  );
};

export default EventView;
